import React from "react";

import { AutoFormFieldProps } from "@autoform/react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";

export function AccordionWrapperField({
  id,
  label,
  field,
  inputProps,
  error,
}: AutoFormFieldProps) {
  const customLabel =
    (field.fieldConfig?.customData as { label?: string } | undefined)?.label ??
    label;

  const { key, ...rest } = inputProps;

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="item-1">
        <AccordionTrigger>{customLabel}</AccordionTrigger>
        <AccordionContent>
          <Input
            id={id}
            className={error ? "border-destructive" : ""}
            {...rest}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
